import { render } from "./PortText.vue?vue&type=template&id=5158b965&scoped=true"
const script = {}

import "./PortText.vue?vue&type=style&index=0&id=5158b965&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5158b965"]])

export default __exports__